const styles = (theme) => ({
  root: {
    padding: "15px",
  },
});

export default styles;
